import React from 'react';

import $image_url from 'js/utils/image_url';
import { Body } from 'js/design_system/Body';

const UNIVERSITY_LOGOS = [
  { alt: 'Oxford', url: 'emails/logos/oxford-black.png' },
  { alt: 'Berkeley', url: 'emails/logos/berkeley-black.png' },
  { alt: 'UNAM', url: 'emails/logos/unam-black.png' },
];

type Props = {
  header: string;
};

export const GateOverlaySocialProof: React.FC<Props> = ({ header }) => (
  <>
    <Body size="sm" className="gate-overlay__social-proof-header">
      {header}
    </Body>
    <div className="gate-overlay__social-proof-logos">
      {UNIVERSITY_LOGOS.map((logo) => (
        <img
          key={logo.alt}
          src={$image_url(logo.url)}
          alt={logo.alt}
          className="gate-overlay__social-proof-logo"
        />
      ))}
    </div>
  </>
);
